import { ThemeModule } from '../../front/lib/ThemeModule';
export class RelatedContent extends ThemeModule {
    constructor() {
        super(...arguments);
        this.placeholderEl = this.getElementById('placeholder');
        this.reloadBtnEl = this.getElementById('reload');
    }
    init() {
        if (!this.placeholderEl) {
            this.destroy();
            return;
        }
        this.searchMatches();
        this.reloadBtnEl.addEventListener('click', () => this.searchMatches());
    }
    async searchMatches() {
        this.root.classList.add('is--loading');
        this.reloadBtnEl.setAttribute('disabled', 'disabled');
        try {
            const resp = await this.restRequest('POST', `search/${this.json.post_id}`, {
                init: {
                    body: JSON.stringify(this.json),
                }
            });
            this.submodules.list.forEach(part => part.destroy());
            this.placeholderEl.innerHTML = resp.payload.html;
        }
        catch (e) {
            console.error(e);
        }
        this.reloadBtnEl.removeAttribute('disabled');
        this.root.classList.remove('is--loading');
    }
}
